import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
  HttpEventType,
  HttpStatusCode,
} from '@angular/common/http';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { LocalizationService } from '../localization.service';
import { RoutesList } from 'src/app/models/enums/RoutesList';
import { PortalLoggedinUsers } from 'src/app/shared/services/portal-loggedin-users.service';
import { PortalLogOutExitCode } from 'src/app/models/enums/logOutExitCode';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private portalLoggedinUsers: PortalLoggedinUsers
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //get auth token
    var token = this.authService.getToken();
    //if the token is present, clone the request
    //replacing the roiginal headers with the authorization
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    //Send the request to the next handler
    return next.handle(req).pipe(
      catchError((error) => {
        let urlWithoutParams = this.router.parseUrl(this.router.url).root.children['primary'].segments.map((it) => it.path).join('/');
        const dontUseReturnUrlValue = error.error?.dontUseReturnUrl;
        
        //Perform logout on 401 - Unautorized or 403 - Forbidden HTTP response errors
        if (
          error instanceof HttpErrorResponse &&
          (error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden) &&
          urlWithoutParams != LocalizationService.getRoute(RoutesList.LoginPageCompareValue)
        ) 
        {
          let exitCode = PortalLogOutExitCode.AuthInterceptor;
          if(error.error?.exitCode)
            exitCode = error.error?.exitCode
          this.authService.logout(exitCode, true);
          let params = window.location.search && window.location.search != '' ? window.location.search : null;
          const anchor = window.location.hash ? window.location.hash.substring(1) : null;
          let navigationOptions:NavigationExtras | undefined = {
            queryParams: { returnUrl: urlWithoutParams, params, anchor },
          };
          if(dontUseReturnUrlValue)
            navigationOptions = undefined;

          this.router.navigate([LocalizationService.getRoute(RoutesList.LoginPage)], navigationOptions);
        }
        return throwError(error);
      })
    );
  }
}
